import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { SlideFrame } from '../SlideFrame';
import { CountdownRing } from '../CountdownRing';
import { recognitionThoughts } from '../../data/deckContent';
export function FormatSlide() {
  const reduced = useReducedMotion();
  return <SlideFrame eyebrow="The recognizable format" index={4} showMiniCountdown={false} data-id="element-66" data-mp="3ujrfag0y08rq">
      <div className="grid grid-cols-[0.72fr_1.28fr] items-center gap-[5%]" data-id="element-67" data-mp="3dqa2o3ns9e0">
        <div className="flex justify-center" data-id="element-68" data-mp="8brvvgsgymt6">
          <CountdownRing data-id="element-69" data-mp="8agq5bfgr4zf" />
        </div>

        <div data-id="element-70" data-mp="d2rowaygwkqe">
          <h2 className="text-[clamp(26px,3.8vw,68px)] font-semibold leading-[1.06] tracking-tight text-white" data-id="element-71" data-mp="d287cvcqbycw">
            The countdown becomes the signal.
          </h2>

          <ul className="mt-[3vh] space-y-[1.3vh]" data-id="element-72" data-mp="i3ns0mazw2ur">
            {recognitionThoughts.map((thought, i) => <motion.li key={thought} initial={reduced ? false : {
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.35,
            delay: 0.06 * i,
            ease: 'easeOut'
          }} className="rounded-[1.1vw] border border-white/10 bg-white/[0.04] px-[1.6vw] py-[1.5vh] text-[clamp(13px,1.5vw,28px)] font-light text-white/85" data-id="element-73" data-mp="r2j1q8d8zv2t" data-mpi={i}>
                “{thought}”
              </motion.li>)}
          </ul>

          <p className="mt-[3vh] max-w-[46ch] text-[clamp(12px,1.25vw,24px)] font-light leading-snug text-white/55" data-id="element-74" data-mp="1bol236s1rc4e">
            The countdown is not the strategy. It is the{' '}
            <span className="font-medium text-[color:var(--sv-green)]" data-id="element-75" data-mp="16s44zn2vdnf6">
              recognition device
            </span>{' '}
            that signals the Solventum promise.
          </p>
        </div>
      </div>
    </SlideFrame>;
}